import {clamp} from '../../utils/clamp';
/**
 * Calculates and returns the value from a percentage of the total.
 * For example, 50% of a 60 would be 30;
 *
 * @param percentage The percentage of the total to get the value of
 * @param total The total value
 * @param shouldClamp (optional) Whether to clamp the value between 0 and `value`. Defaults to true
 * @returns The timestamp
 */
export function getValueFromPercentage(
  percentage: number,
  total: number,
  shouldClamp = true
): number {
  const effectivePercentage = shouldClamp
    ? clamp(percentage, 0, 100)
    : percentage;
  return (effectivePercentage / 100) * total;
}
